import * as React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';

import EmployerGettingStartedPage from '../components/organisations/autonomous-create-organization';
import { getServerTranslations } from '../get-server-side-translations';

const GettingStartedPage: React.FunctionComponent = () => (
  <>
    <Head>
      <title>Inizia con Restworld - Crea il tuo locale</title>
      <meta
        name="description"
        content="Inizia a utilizzare Restworld per trovare il personale perfetto per il tuo locale. Crea il tuo profilo aziendale e pubblica annunci di lavoro in pochi minuti."
      />
      <meta property="og:title" content="Inizia con Restworld - Crea il tuo locale" />
      <meta
        property="og:description"
        content="Inizia a utilizzare Restworld per trovare il personale perfetto per il tuo locale. Crea il tuo profilo aziendale e pubblica annunci di lavoro in pochi minuti."
      />
      <meta
        property="og:image"
        content="https://restworld-assets.s3.eu-west-1.amazonaws.com/showcase-getting-started.png"
      />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Inizia con Restworld - Crea il tuo locale" />
      <meta
        name="twitter:description"
        content="Inizia a utilizzare Restworld per trovare il personale perfetto per il tuo locale. Crea il tuo profilo aziendale e pubblica annunci di lavoro in pochi minuti."
      />
      <meta
        name="twitter:image"
        content="https://restworld-assets.s3.eu-west-1.amazonaws.com/showcase-getting-started.png"
      />
    </Head>
    <EmployerGettingStartedPage />
  </>
);

export default GettingStartedPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, ['common', 'restaurant-onboarding']);
  return {
    props: {
      ...translation,
    },
  };
};
